<app-base-entry-page-template entryTitle="My Profile" [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving" (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-base-entry-page-content-template>
    <app-client-form *ngIf="value" [(formGroupRef)]="formGroupRef" [(value)]="value"></app-client-form>
  </app-base-entry-page-content-template>
  <app-base-entry-page-footer-template>
  </app-base-entry-page-footer-template>
</app-base-entry-page-template>
